<!DOCTYPE html>
<html lang="en">
<head>
  <link href="https://fonts.googleapis.com/css2?family=Poppins&display=swap" rel="stylesheet">
<meta charset="utf-8">
</head>
<body style="height:100%; width:100%">
    <div id="header" style="position:absolute; top:0px; left:0px; height:100px; right:0px;overflow:hidden;text-align: center;"> 
      <div style="width: 155px; height: 54px; float: left; " [hidden]="!showBackButton">
          <a href="#" [hidden]="!showBackButton"  (click)="onBackClicked()" style="z-index: 5000; width: 100; height: 100; float: left; margin-top: 25px; margin-left: 25px; position:relative;" ><img src="../assets/BackButton.png"  /></a>
      </div>

      <span class="appTitle">{{title}}</span>
      
      <img src="../assets/logo.png"  ngClass={{loggedIn}}>
            <div style="width: 155px; height: 54px; float: left; " [hidden]="!showBackButton">
      </div>

    </div> 
    <div id="content" style="position:absolute; top:100px; bottom:20px; left:25px; right:25px; overflow:auto;"> 
      <router-outlet></router-outlet>
    </div> 
    <div id="footer" style="position:absolute; bottom:0px; height:20px; left:0px; right:0px; overflow:hidden;"> 
    </div>
  </body>
</html>


